module.exports = __webpack_public_path__ + "static/media/hp-cs-dennik.c2eee2bf.png";